(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sliding-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sliding-tabs-block')) {
    class SlidingTabsBlock extends HTMLElement {
      connectedCallback() {
        this.tablist = this.querySelector('[data-sliding-tabs-nav]');
        this.buttons = Array.from(
          this.querySelectorAll('[data-sliding-tabs-button]')
        );
        this.panels = Array.from(
          this.querySelectorAll('[data-sliding-tabs-panel]')
        );
        this.indicator = this.querySelector('[data-sliding-tabs-indicator]');

        if (!this.tablist || !this.buttons.length || !this.panels.length) {
          return;
        }

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onResize = this.onResize.bind(this);

        this.tablist.addEventListener('click', this.onClick);
        this.tablist.addEventListener('keydown', this.onKeydown);
        window.addEventListener('resize', this.onResize);

        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(() => {
            this.updateIndicator();
          });
          this.resizeObserver.observe(this.tablist);
        }

        const defaultTabNumber = this.dataset.defaultTab;
        const defaultButton =
          this.buttons.find((button) => {
            return button.dataset.tabNumber === defaultTabNumber;
          }) || this.buttons[0];

        this.activateTab(defaultButton, false);
      }

      disconnectedCallback() {
        if (this.tablist) {
          this.tablist.removeEventListener('click', this.onClick);
          this.tablist.removeEventListener('keydown', this.onKeydown);
        }

        window.removeEventListener('resize', this.onResize);

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }

      onClick(event) {
        const button = event.target.closest('[data-sliding-tabs-button]');

        if (!button || !this.contains(button)) {
          return;
        }

        this.activateTab(button, true);
      }

      onKeydown(event) {
        const currentIndex = this.buttons.findIndex((button) => {
          return button.getAttribute('aria-selected') === 'true';
        });

        let nextIndex = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = (currentIndex + 1) % this.buttons.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex =
              (currentIndex - 1 + this.buttons.length) % this.buttons.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.buttons.length - 1;
            break;
          default:
            break;
        }

        if (nextIndex === null) {
          return;
        }

        event.preventDefault();
        this.activateTab(this.buttons[nextIndex], true);
      }

      onResize() {
        this.updateIndicator();
      }

      activateTab(activeButton, shouldFocus) {
        if (!activeButton) {
          return;
        }

        this.buttons.forEach((button) => {
          const isActive = button === activeButton;
          const controls = button.getAttribute('aria-controls');
          const panel = this.querySelector(`#${controls}`);

          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          button.setAttribute('tabindex', isActive ? '0' : '-1');

          if (panel) {
            panel.hidden = !isActive;
          }
        });

        if (shouldFocus) {
          activeButton.focus();
        }

        this.updateIndicator();
      }

      updateIndicator() {
        if (!this.indicator || !this.tablist) {
          return;
        }

        const activeButton = this.buttons.find((button) => {
          return button.getAttribute('aria-selected') === 'true';
        });

        if (!activeButton) {
          this.indicator.style.opacity = '0';
          return;
        }

        const tablistRect = this.tablist.getBoundingClientRect();
        const buttonRect = activeButton.getBoundingClientRect();

        this.indicator.style.width = `${buttonRect.width}px`;
        this.indicator.style.transform = `translateX(${
          buttonRect.left - tablistRect.left
        }px)`;
        this.indicator.style.opacity = '1';
      }
    }

    customElements.define('sliding-tabs-block', SlidingTabsBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
